


















































































































































































































// Vue
import Vue, { PropType } from "vue";
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// Models
import { ClientModel, DaysOfWeek, UserModel, UserRole } from "@/core/api/apiClient";
import { AuthUser } from "@/core/_models/authUser.model";
// Services
import AdminService from "@/views/admin/Admin.service";
// Components
import ConfirmationDialog from "@/core/components/content/_dialogs/ConfirmationDialog.vue";
import CreateUserDialog from "@/views/admin/_dialogs/users/CreateUserDialog.vue";
import UpdateUserDialog from "@/views/admin/_dialogs/users/UpdateUserDialog.vue";
import DaysSelector from "@/core/components/content/DaysSelector.vue";
import mapUserRole from "@/core/helpers/enum_mappings/UserRole";

export default Vue.extend({
  name: "UpdateSystemClientDialog",
  props: {
    client: Object as PropType<ClientModel>
  },
  components: { ConfirmationDialog, CreateUserDialog, UpdateUserDialog, DaysSelector },

  data() {
    return {
      dialog: false,
      isLoading: false,
      isConfirmed: false,

      search: "",

      name: "",
      companyLogo: "",
      mainThemeColor: "",
      myFile: null as File | null,
      workingDays: [] as DaysOfWeek[],

      usersData: [] as UserModel[],
      mapUserRole,
      UserRole
    };
  },

  mixins: [validationMixin],

  validations: {
    mainThemeColor: { required },
    workingDays: { required }
  },

  methods: {
    ...mapActions("users", {
      removeUser: "removeUser"
    }),

    ...mapActions("clients", {
      removeClient: "removeClient"
    }),

    initialize(): void {
      const currentUser = this.currentUser as AuthUser;

      if (this.client) {
        this.name = this.client.name ?? "";
        this.companyLogo = this.client.companyLogoUrl ?? "";
        this.mainThemeColor = this.client.mainThemeColor ?? "";
        this.workingDays = currentUser.client!.workingDays ?? Object.values(DaysOfWeek);
        this.getAllClientUsers();
      }
    },

    getAllClientUsers(): void {
      this.isLoading = true;

      AdminService.getAllClientUsers(this.client.clientId!)
        .then((data: UserModel[]) => {
          if (!data) return;

          // ! Remove the Impersonation User from the display
          const impersonationUser = data.find((element) => element.firstName === "Impersonation");
          if (impersonationUser) {
            const index = data.indexOf(impersonationUser);
            data.splice(index, 1);
          }

          this.usersData = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getImageUrlWithCacheBust(imageUrl: string): string {
      if (!imageUrl) return imageUrl;
      const separator = imageUrl.includes("?") ? "&" : "?";
      return `${imageUrl}${separator}t=${Date.now()}`;
    },

    async submit(): Promise<void> {
      this.isLoading = true;

      // Build payload
      const payload = new ClientModel({
        clientId: this.client.clientId,
        name: this.name,
        companyLogoUrl: this.companyLogo,
        mainThemeColor: this.mainThemeColor,
        mainThemeTextColor: "#FFFFFF",
        jobSchedulerTimeIntervals: this.client.jobSchedulerTimeIntervals,
        workingDays: this.workingDays
      });

      // Handles submission if a user uploads a new Company Logo
      if (this.myFile) {
        const uploadFile = this.myFile;

        const updateLogoResponse = await AdminService.updateClientLogo(this.client.clientId, uploadFile);
        payload.companyLogoUrl = updateLogoResponse?.companyLogoUrl;
      }

      AdminService.updateClient(this.client.clientId!, payload).then((response: any) => {
        if (!response) return;

        this.$emit("refresh-clients");
        this.isLoading = false;
        this.close();
      });
    },

    deleteClient(): void {
      this.removeClient(this.client).then(() => {
        this.$emit("refresh-clients");
      });
    },

    deleteUser(payload: any): void {
      this.removeUser(payload).then(() => {
        this.getAllClientUsers();
        if (payload.UserType === "Driver") this.$store.dispatch("SET_UPDATE_DASHBOARD", true);
      });
    },

    close(): void {
      this.name = "";
      this.companyLogo = "";
      this.mainThemeColor = "";
      this.myFile = null;

      this.dialog = false;
    }
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" }),

    filteredUsers(): any {
      return this.usersData.filter((element: UserModel): any => {
        const fullName = element.firstName + " " + element.lastName;
        const userRole = mapUserRole(element.role);
        const email = element.email;

        return (
          fullName.toLowerCase().includes(this.search.toLowerCase()) ||
          email?.toLowerCase().includes(this.search.toLocaleLowerCase()) ||
          userRole.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },

    headers(): any[] {
      return [
        {
          text: "Last Name",
          value: "lastName",
          sortable: true
        },
        {
          text: "First Name",
          value: "firstName",
          sortable: true
        },
        {
          text: "Role",
          value: "role",
          sortable: true
        },
        {
          text: "Email",
          value: "email",
          sortable: true
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false
        }
      ];
    }
  }
});
